import TopMenu from '../components/TopMenu';
import BottomMenu from '../components/BottomMenu';
import httlogo from '../images/httcrop.png';
import { Image, Row, Col, Container } from 'react-bootstrap';

function BlankPage() {
    return (
        <div>
            <Image
                src={httlogo}
                alt="background"
                style={{
                    top: 0,
                    left: window.innerWidth < 768 ? '110px' : '30px',
                    height: '75px',
                }}
            />
            <TopMenu />

            <Container>
                <h2 className='htitleb text-center'>Neighbor Island Affiliates</h2>
                <hr />
                <Row className='justify-content-center'>
                    <Col md={4}>
                        <h5>R&D Equipment Repair (Island of Hawaii)</h5>
                        <p>16-579 Kipimana St Keaau, HI 96749</p>
                        <p>(808)966-9922 <br />
                            Fax: (808) 966-4590</p>
                    </Col>
                     <Col md={4}>
                        <h5>DMS Diesel Repair (Island of Hawaii)</h5>
                        <p>24 Railroad Ave, Hilo, HI 96720</p>
                        <p>(808) 935-6484</p>
                    </Col>
                </Row>
                <br />
                <Row className='justify-content-center'>
                    <Col md={4}>
                        <h5>Newera Diesel Repair (Maui)</h5>
                        <p>2000 Mokulele Hwy
                            Kahului, HI 96732</p>
                        <p>(808) 633-1683</p>
                    </Col>

                    <Col md={4}>
                        <h5>Wayne's Enterprises (Kauai)</h5>
                        <p>4421 Pahee St Lihue, HI 96766</p>
                        <p>(808)246-6673</p>
                    </Col>
                </Row>

            </Container>
            <BottomMenu />
        </div>
    );
}

export default BlankPage;